import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/asymmetrik': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M517.5 309.2C556.3 269.2 575.6 229.2 576 193.1 576.8 127.6 516.6 74.9 406.6 58.1 277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3 245.2 61.8 323.7 56.9 392 67.5 544.5 91.3 588.8 195 490.8 299.2 480.6 310 468.8 320.3 455.8 329.8L304.9 103.4 114.7 388.9C49.1 359.5 38.2 298.7 95.6 237.7 116.4 215.5 143.9 195.8 175.1 179.6 195.1 167.4 214.8 157 237.1 148.9 172 169.2 114.4 201.8 75.5 241.8 47.8 270.4 34.1 298.9 33.8 324.7 33.3 359.8 57.2 389.8 102.2 407.7L67.7 459.4H169.3L191.3 425C213.5 426 236.6 425 259.9 422.3L237.1 459.4H372.6L340 406.3C358.6 401 376.9 394.8 394.5 387.6L440.4 459.4H542L468.6 349C487.1 336.9 503.6 323.5 517.5 309.2zM329.9 389.7L304.9 349.1 272.2 402.4C248.8 405.9 225.5 407.5 203 406.8L304.9 247.5 383.6 370.5C366.4 377.9 348.3 384.4 329.9 389.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/asymmetrik.js
// module id = y5rv
// module chunks = 144